<script setup>
</script>

<template>
    <div>
        <slot/>
    </div>
</template>
